import styled from 'styled-components';
import mediaQueries from 'constants/mediaQueries';

export const Wrapper = styled.div`
  margin: 32px 0;
  text-align: center;

  ${mediaQueries.mobileOnly} {
    margin: 28px 0;
    text-align: left;
  }
`;

export const BodyWrapper = styled.div`
  margin-top: 20px;

  ${mediaQueries.mobileOnly} {
    margin-top: 16px;
  }
`;
